import { HttpRequestPost } from './../../service/index';
import PushNotifications from "../symbols/pushNotifications";

type GetPushNotificationsRequestModel = {
  Query: string;
};
const pushNotificationsAction = () => ({
  type: PushNotifications.PUSH_NOTIFICATIONS,
});
const pushNotificationsSuccessAction = (data: any) => ({
  type: PushNotifications.PUSH_NOTIFICATIONS_SUCCESS,
  payload: data,
});
const pushNotificationsFailureAction = (data: any) => ({
  type: PushNotifications.PUSH_NOTIFICATIONS_FAILURE,
  payload: data,
});
const clearPushNotificationsAction = () => ({
  type: PushNotifications.CLEAR_PUSH_NOTIFICATIONS,
});

export function getPushNotifications(data?: GetPushNotificationsRequestModel, callback?: (resp?) => void) {
  let url = `/admin/push-notifications`;
  return (dispatch: any) => {
    dispatch(pushNotificationsAction());
    HttpRequestPost(
      url,
      dispatch,
      pushNotificationsSuccessAction,
      pushNotificationsFailureAction,
      true,
      data || {
        Query: '',
      },
      callback
    );
  };
}

export function clearPushNotifications() {
  return (dispatch: any) => {
    dispatch(clearPushNotificationsAction());
  };
}
